<div>
    <forgot-password></forgot-password>
</div>

